import styled from 'styled-components';
import breakpoint from '~/utils/style-utils';

export const CarouselWrapper = styled.div<{ $alignSelf: React.CSSProperties['alignSelf'] }>`
	position: relative;
	overflow: hidden;
	// force browser to create a new composite layer for faster rendering
	transform: translate3d(0, 0, 0);
	align-self: ${({ $alignSelf }) => $alignSelf};
`;

export const CarouselScroller = styled.div<{
	disableEndGap: boolean;
	$scrollerPadding: React.CSSProperties['padding'];
}>`
	display: grid;
	grid-auto-flow: column;
	justify-content: flex-start;
	grid-gap: ${({ disableEndGap }) => (disableEndGap ? '0' : '6px')};
	padding: ${({ $scrollerPadding }) => $scrollerPadding};
	width: auto;
	scrollbar-width: none;
	scroll-snap-type: x mandatory;
	-webkit-overflow-scrolling: touch;
	-ms-overflow-style: none;
	overflow: auto;

	&::-webkit-scrollbar {
		display: none;
	}

	&:after {
		content: '';
		width: ${({ disableEndGap }) => (disableEndGap ? '0' : '20px')};
		right: 0;

		${({ disableEndGap }) => breakpoint.lg`
    	width: ${disableEndGap ? '0' : '25px'};
  	`}
	}
`;

export const CarouselControls = styled.div`
	overflow: visible;
	position: absolute;
	width: 100%;
	height: 100%;
	z-index: 1;
	pointer-events: none;
`;

export const CarouselArrow = styled.button`
	display: inline-block;
	width: 24px;
	height: 42px;
	background: rgba(var(--category-arrow-bg), 1);
	cursor: pointer;
	outline: none;
	z-index: 1;
	position: absolute;
	pointer-events: auto;

	&:after {
		content: '';
		position: absolute;
		background: transparent;
		width: 40px;
		height: 80px;
		border-radius: 50%;
		bottom: -50%;
	}

	.icon--sprite {
		fill: var(--category-arrow-icon-color, rgb(var(--base-02)));
		width: 20px;
		height: 20px;
		position: relative;
	}
`;

export const ArrowLeft = styled(CarouselArrow)`
	border-bottom-right-radius: 42px;
	border-top-right-radius: 42px;
	left: 0;
	top: calc(50% - 21px);

	.icon--sprite {
		left: -2px;
	}

	&:after {
		right: -20px;

		${breakpoint.lg`
			width: 80px;
    	right: -40px;
  	`}
	}
`;

export const ArrowRight = styled(CarouselArrow)`
	border-bottom-left-radius: 42px;
	border-top-left-radius: 42px;
	right: 0;
	top: calc(50% - 21px);

	.icon--sprite {
		right: -3px;
	}

	&:after {
		left: -20px;

		${breakpoint.lg`
			width: 80px;
			left: -40px;
		`}
	}
`;
